<template>
  <div class="trbo-a-questions-header">
    <div class="trbo-a-questions-header__top">
      <div class="trbo-a-questions-header__top__avatar">
        <question-avatar
          :image-url="settings.avatar.imageUrl"
          :name="settings.avatar.name"
        />
      </div>
      <div class="trbo-a-questions-header__top__progress-bar">
        <question-progress-bar
          :settings="settings.progressBar"
          @progress-bar-item-click="onProgressBarItemClick"
        />
      </div>
      <div class="trbo-a-questions-header__top__buttons">
        <question-restart-button
          :disabled="isDisabledRestartButton"
          @click="onClickRestart"
        />
        <div v-if="settings.showCloseButton" class="trbo-a-questions-header__top__buttons__close">
          <question-close-button
            @click="onClickGoToLandingPage"
          />
        </div>
      </div>
    </div>
    <div v-if="settings.topMessage" class="trbo-a-questions-header__bottom">
      <top-message
        v-if="settings.topMessage.title || settings.topMessage.description"
        :title="settings.topMessage.title"
        :description="settings.topMessage.description"
        @link-from-message-click="onClickLinkFromMessage"
      />
    </div>
    <div v-if="settings.isCurrentProductsPage && settings.isSortingEnabled" class="trbo-a-questions-header__actions">
      <sort-dropdown />
    </div>
    <div v-if="settings.isSearchEnabled" class="trbo-a-questions-header__search-box">
      <search-box :initial-value="settings.optionSearchQuery" @search="query => $emit('search', query)" />
    </div>
  </div>
</template>

<script>
// @flow

import SearchBox from '../../SearchBox/SearchBox.vue'
import QuestionAvatar from '../QuestionAvatar/QuestionAvatar.vue'
import QuestionRestartButton from '../QuestionRestartButton/QuestionRestartButton.vue'
import QuestionCloseButton from '../QuestionCloseButton/QuestionCloseButton.vue'
import QuestionProgressBar from '../QuestionProgressBar/QuestionProgressBar.vue'
import TopMessage from '../TopMessage/TopMessage.vue'
import SortDropdown from './SortDropdown.vue'

export default {
  components: {
    QuestionAvatar,
    QuestionRestartButton,
    QuestionCloseButton,
    QuestionProgressBar,
    TopMessage,
    SortDropdown,
    SearchBox
  },
  props: {
    settings: {
      type: Object, // QuestionHeaderSettings
      required: true
    }
  },
  computed: {
    isDisabledRestartButton (): boolean {
      return this.settings.progressBar.wizardPageIndex === 0
    }
  },
  methods: {
    onClickRestart (): void {
      this.$emit('restart')
    },
    onClickGoToLandingPage (): void {
      this.$emit('go-to-landing-page')
    },
    onProgressBarItemClick (item: Object): void {
      this.$emit('progress-bar-item-click', item)
    },
    onClickLinkFromMessage (url: string): void {
      this.$emit('link-from-message-click', url)
    }
  }
}
</script>

<style scoped src="./question-header.scss" />
